export enum CampaignStatus {
  Active,
  Stopped,
  WithTraffic,
  Deleted,
}
